const crossSells = {
	"zymoprep-yeast-plasmid-miniprep-i": {
		"cat_number": "D2001",
		"product_handle": "zymoprep-yeast-plasmid-miniprep-i",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zymoprep-yeast-plasmid-miniprep-ii": {
		"cat_number": "D2004",
		"product_handle": "zymoprep-yeast-plasmid-miniprep-ii",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zymoprep-96-yeast-plasmid-miniprep": {
		"cat_number": "D2005",
		"product_handle": "zymoprep-96-yeast-plasmid-miniprep",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zymopure-ii-plasmid-midiprep-kit-sample": {
		"cat_number": "D4200S",
		"product_handle": "zymopure-ii-plasmid-midiprep-kit-sample",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zymopure-ii-plasmid-midiprep-kit": {
		"cat_number": "D4200S",
		"product_handle": "zymopure-ii-plasmid-midiprep-kit",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zymopure-ii-plasmid-maxiprep-kit": {
		"cat_number": "D4202",
		"product_handle": "zymopure-ii-plasmid-maxiprep-kit",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zymopure-ii-plasmid-maxiprep-kit-sample": {
		"cat_number": "D4202S",
		"product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zymopure-ii-plasmid-gigaprep-kit": {
		"cat_number": "D4204",
		"product_handle": "zymopure-ii-plasmid-gigaprep-kit",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zymopure-ii-plasmid-miniprep-kit-sample": {
		"cat_number": "D4208S",
		"product_handle": "zymopure-ii-plasmid-miniprep-kit-sample",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zymopure-ii-plasmid-miniprep-kit": {
		"cat_number": "D4208T",
		"product_handle": "zymopure-ii-plasmid-miniprep-kit",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zymopure-express-plasmid-midiprep-kit": {
		"cat_number": "D4213",
		"product_handle": "zymopure-express-plasmid-midiprep-kit",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zymopure-96-plasmid-miniprep-kit": {
		"cat_number": "D4214",
		"product_handle": "zymopure-96-plasmid-miniprep-kit",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zyppy-plasmid-miniprep-kit": {
		"cat_number": "D4019",
		"product_handle": "zyppy-plasmid-miniprep-kit",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zyppy-96-plasmid-kit": {
		"cat_number": "D4041",
		"product_handle": "zyppy-96-plasmid-kit",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zyppy-96-plasmid-magbead-kit": {
		"cat_number": "D4100",
		"product_handle": "zyppy-96-plasmid-magbead-kit",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zr-bac-dna-miniprep-kit": {
		"cat_number": "D4048",
		"product_handle": "zr-bac-dna-miniprep-kit",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"zr-plasmid-miniprep-classic": {
		"cat_number": "D4015",
		"product_handle": "zr-plasmid-miniprep-classic",
		"recc_product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"statement": "Recover highly concentrated pure DNA from Agarose Gels:"
	},
	"ez-dna-methylation-lightning-automation-kit": {
		"cat_number": "D5049",
		"product_handle": "ez-dna-methylation-lightning-automation-kit",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Efficiently purify DNA ideal for DNA Methylation Analysis:"
	},
	"ez-dna-methylation-lightning-kit": {
		"cat_number": "D5030",
		"product_handle": "ez-dna-methylation-lightning-kit",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Efficiently purify DNA ideal for DNA Methylation Analysis:"
	},
	"ez-dna-methylation-lightning-kit-sample": {
		"cat_number": "D5030S",
		"product_handle": "ez-dna-methylation-lightning-kit-sample",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Efficiently purify DNA ideal for DNA Methylation Analysis:"
	},
	"ez-96-dna-methylation-lightning-magprep": {
		"cat_number": "D5046",
		"product_handle": "ez-96-dna-methylation-lightning-magprep",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Efficiently purify DNA ideal for DNA Methylation Analysis:"
	},
	"ez-96-dna-methylation-lightning-kit": {
		"cat_number": "D5032",
		"product_handle": "ez-96-dna-methylation-lightning-kit",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Efficiently purify DNA ideal for DNA Methylation Analysis:"
	},
	"ez-dna-methylation-kit": {
		"cat_number": "D5001",
		"product_handle": "ez-dna-methylation-kit",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Efficiently purify DNA ideal for DNA Methylation Analysis:"
	},
	"ez-96-dna-methylation-kit": {
		"cat_number": "D5003",
		"product_handle": "ez-96-dna-methylation-kit",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Efficiently purify DNA ideal for DNA Methylation Analysis:"
	},
	"ez-96-dna-methylation-magprep": {
		"cat_number": "D5040",
		"product_handle": "ez-96-dna-methylation-magprep",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Efficiently purify DNA ideal for DNA Methylation Analysis:"
	},
	"ez-dna-methylation-gold-kit": {
		"cat_number": "D5005",
		"product_handle": "ez-dna-methylation-gold-kit",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Efficiently purify DNA ideal for DNA Methylation Analysis:"
	},
	"ez-96-dna-methylation-gold-magprep": {
		"cat_number": "D5042",
		"product_handle": "ez-96-dna-methylation-gold-magprep",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Efficiently purify DNA ideal for DNA Methylation Analysis:"
	},
	"ez-96-dna-methylation-gold-kit": {
		"cat_number": "D5007",
		"product_handle": "ez-96-dna-methylation-gold-kit",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Efficiently purify DNA ideal for DNA Methylation Analysis:"
	},
	"ez-dna-methylation-startup-kit": {
		"cat_number": "D5024",
		"product_handle": "ez-dna-methylation-startup-kit",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Efficiently purify DNA ideal for DNA Methylation Analysis:"
	},
	"mix-and-go-competent-cells-dh5-alpha-sample": {
		"cat_number": "T3007S",
		"product_handle": "mix-and-go-competent-cells-dh5-alpha-sample",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"mix-and-go-e-coli-transformation-kit": {
		"cat_number": "T3001",
		"product_handle": "mix-and-go-e-coli-transformation-kit",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"mix-and-go-competent-cells-dh5-alpha": {
		"cat_number": "T3007",
		"product_handle": "mix-and-go-competent-cells-dh5-alpha",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"mix-and-go-competent-cells-zymo-10b": {
		"cat_number": "T3019",
		"product_handle": "mix-and-go-competent-cells-zymo-10b",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"mix-and-go-competent-cells-jm109": {
		"cat_number": "T3003",
		"product_handle": "mix-and-go-competent-cells-jm109",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"mix-and-go-competent-cells-hb101": {
		"cat_number": "T3011",
		"product_handle": "mix-and-go-competent-cells-hb101",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"mix-and-go-competent-cells-tg1": {
		"cat_number": "T3017",
		"product_handle": "mix-and-go-competent-cells-tg1",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"mix-and-go-competent-cells-xjbde3-autolysis": {
		"cat_number": "T3051",
		"product_handle": "mix-and-go-competent-cells-xjbde3-autolysis",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"mix-and-go-competent-cells-xjade3-autolysis": {
		"cat_number": "T3031",
		"product_handle": "mix-and-go-competent-cells-xjade3-autolysis",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"mix-and-go-competent-cells-xjb-autolysis": {
		"cat_number": "T3041",
		"product_handle": "mix-and-go-competent-cells-xjb-autolysis",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"mix-and-go-competent-cells-xja-autolysis": {
		"cat_number": "T3021",
		"product_handle": "mix-and-go-competent-cells-xja-autolysis",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"xjade3-autolysis-glycerol-stock": {
		"cat_number": "T5031",
		"product_handle": "xjade3-autolysis-glycerol-stock",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"xja-autolysis-glycerol-stock": {
		"cat_number": "T5021",
		"product_handle": "xja-autolysis-glycerol-stock",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"xjb-autolysis-glycerol-stock": {
		"cat_number": "T5041",
		"product_handle": "xjb-autolysis-glycerol-stock",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"zymoclean-gel-dna-recovery-kit-sample": {
		"cat_number": "D4001S",
		"product_handle": "zymoclean-gel-dna-recovery-kit-sample",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"zymoclean-gel-dna-recovery-kit": {
		"cat_number": "D4001",
		"product_handle": "zymoclean-gel-dna-recovery-kit",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"dna-clean-concentrator-25": {
		"cat_number": "D4006",
		"product_handle": "dna-clean-concentrator-25",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"dna-clean-concentrator-magbead-kit": {
		"cat_number": "D4012",
		"product_handle": "dna-clean-concentrator-magbead-kit",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"zr-96-dna-clean-up-kit": {
		"cat_number": "D4017",
		"product_handle": "zr-96-dna-clean-up-kit",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"zr-96-zymoclean-gel-dna-recovery-kit": {
		"cat_number": "D4021",
		"product_handle": "zr-96-zymoclean-gel-dna-recovery-kit",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"zr-96-zymoclean-gel-dna-recovery-kit": {
		"cat_number": "D4022",
		"product_handle": "zr-96-zymoclean-gel-dna-recovery-kit",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"dna-clean-concentrator-5-sample": {
		"cat_number": "D4003S",
		"product_handle": "dna-clean-concentrator-5-sample",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"zr-96-dna-clean-up-kit": {
		"cat_number": "D4018",
		"product_handle": "zr-96-dna-clean-up-kit",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"zr-96-dna-clean-amp-concentrator-5-deep-well": {
		"cat_number": "D4023",
		"product_handle": "zr-96-dna-clean-amp-concentrator-5-deep-well",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"zr-96-dna-clean-amp-concentrator-5-deep-well": {
		"cat_number": "D4024",
		"product_handle": "zr-96-dna-clean-amp-concentrator-5-deep-well",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"zymoclean-large-fragment-dna-recovery": {
		"cat_number": "D4045",
		"product_handle": "zymoclean-large-fragment-dna-recovery",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"zymoclean-large-fragment-dna-recovery": {
		"cat_number": "D4046",
		"product_handle": "zymoclean-large-fragment-dna-recovery",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"dna-clean-concentrator-5": {
		"cat_number": "D4013",
		"product_handle": "dna-clean-concentrator-5",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"dna-clean-concentrator-100": {
		"cat_number": "D4029",
		"product_handle": "dna-clean-concentrator-100",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"dna-clean-concentrator-500": {
		"cat_number": "D4031",
		"product_handle": "dna-clean-concentrator-500",
		"recc_product_handle": "zymopure-ii-plasmid-maxiprep-kit-sample",
		"statement": "Purify up to 3 mg of transfection-grade plasmid in 16 minutes:"
	},
	"ez-dna-methylation-direct-kit": {
		"cat_number": "D5021",
		"product_handle": "ez-dna-methylation-direct-kit",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Efficiently purify DNA, ideal for DNA Methylation Analysis::"
	},
	"dna-rna-shield": {
		"cat_number": "R1100-50",
		"product_handle": "dna-rna-shield",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Extract ultra-pure DNA from any sample type:"
	},
	"dna-rna-shield-safecollect-saliva-collection-kit": {
		"cat_number": "R1211-E",
		"product_handle": "dna-rna-shield-safecollect-saliva-collection-kit",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Extract ultra-pure DNA from any sample type:"
	},
	"dna-rna-shield-collection-tube-w-swab": {
		"cat_number": "R1106",
		"product_handle": "dna-rna-shield-collection-tube-w-swab",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Extract ultra-pure DNA from any sample type:"
	},
	"dna-rna-shield-safecollect-swab-collection-kit": {
		"cat_number": "R1160-E",
		"product_handle": "dna-rna-shield-safecollect-swab-collection-kit",
		"recc_product_handle": "quick-dna-miniprep-plus-kit-sample",
		"statement": "Extract ultra-pure DNA from any sample type:"
	},
	"dna-rna-shield-blood-collection-tube": {
		"cat_number": "R1150",
		"product_handle": "dna-rna-shield-blood-collection-tube",
		"recc_product_handle": "quick-dna-rna-blood-tube-kit",
		"statement": "Extract pure DNA & RNA directly from blood ready for downstrem applications:"
	},
	"urine-conditioning-buffer": {
		"cat_number": "D3061-1-8",
		"product_handle": "urine-conditioning-buffer",
		"recc_product_handle": "quick-dna-urine-kit",
		"statement": "Easy, reliable, and rapid isolation of cellular and/or cell-free DNA from up to 40 ml of urine:"
	},
	"urine-collection-cup": {
		"cat_number": "D3062-1",
		"product_handle": "urine-collection-cup",
		"recc_product_handle": "quick-dna-urine-kit",
		"statement": "Easy, reliable, and rapid isolation of cellular and/or cell-free DNA from up to 40 ml of urine:"
	},
	"urine-collection-kit": {
		"cat_number": "D3062",
		"product_handle": "urine-collection-kit",
		"recc_product_handle": "quick-dna-urine-kit",
		"statement": "Easy, reliable, and rapid isolation of cellular and/or cell-free DNA from up to 40 ml of urine:"
	},
	"rna-clean-concentrator-5": {
		"cat_number": "R1013",
		"product_handle": "rna-clean-concentrator-5",
		"recc_product_handle": "direct-zol-rna-miniprep-kits-sample",
		"statement": "RNA from Trizol in 7 minutes:"
	},
	"rna-clean-concentrator-96": {
		"cat_number": "R1080",
		"product_handle": "rna-clean-concentrator-96",
		"recc_product_handle": "direct-zol-rna-miniprep-kits-sample",
		"statement": "RNA from Trizol in 7 minutes:"
	},
	"rna-clean-concentrator-25": {
		"cat_number": "R1017",
		"product_handle": "rna-clean-concentrator-25",
		"recc_product_handle": "direct-zol-rna-miniprep-kits-sample",
		"statement": "RNA from Trizol in 7 minutes:"
	},
	"rna-clean-concentrator-100": {
		"cat_number": "R1019",
		"product_handle": "rna-clean-concentrator-100",
		"recc_product_handle": "direct-zol-rna-miniprep-kits-sample",
		"statement": "RNA from Trizol in 7 minutes:"
	},
	"rna-clean-concentrator-magbead": {
		"cat_number": "R1081",
		"product_handle": "rna-clean-concentrator-magbead",
		"recc_product_handle": "direct-zol-rna-miniprep-kits-sample",
		"statement": "RNA from Trizol in 7 minutes:"
	},
	"direct-zol-rna-miniprep-and-lysis-tubes": {
		"cat_number": "R2050",
		"product_handle": "direct-zol-rna-miniprep-and-lysis-tubes",
		"recc_product_handle": "rna-clean-concentrator-5-sample",
		"statement": "Concentrated, NGS ready RNA in 5 minutes:"
	},
	"direct-zol-rna-miniprep-kits": {
		"cat_number": "R2052",
		"product_handle": "direct-zol-rna-miniprep-kits",
		"recc_product_handle": "rna-clean-concentrator-5-sample",
		"statement": "Concentrated, NGS ready RNA in 5 minutes:"
	},
	"direct-zol-rna-miniprep-plus-kits": {
		"cat_number": "R2072",
		"product_handle": "direct-zol-rna-miniprep-plus-kits",
		"recc_product_handle": "rna-clean-concentrator-5-sample",
		"statement": "Concentrated, NGS ready RNA in 5 minutes:"
	},
	"direct-zol-96-rna-kits": {
		"cat_number": "R2054",
		"product_handle": "direct-zol-96-rna-kits",
		"recc_product_handle": "rna-clean-concentrator-5-sample",
		"statement": "Concentrated, NGS ready RNA in 5 minutes:"
	},
	"direct-zol-rna-microprep-kits": {
		"cat_number": "R2062",
		"product_handle": "direct-zol-rna-microprep-kits",
		"recc_product_handle": "rna-clean-concentrator-5-sample",
		"statement": "Concentrated, NGS ready RNA in 5 minutes:"
	},
	"direct-zol-dna-rna-miniprep": {
		"cat_number": "R2080T",
		"product_handle": "direct-zol-dna-rna-miniprep",
		"recc_product_handle": "rna-clean-concentrator-5-sample",
		"statement": "Concentrated, NGS ready RNA in 5 minutes:"
	}
}